<ng-container [ngSwitch]="type">
  <div *ngSwitchCase="1" class="card py-2 text-center card_type_1" [class.tile]="tileHoverEffect">
    <div class="card-header">
      <ng-content select="[cardHeader1]"></ng-content>
      <ng-content select="[cardTitle1]"></ng-content>
      <div class="card-subtitle mb-2 text-muted_1">
        <ng-content select="[cardSubtitle1]"></ng-content>
      </div>
    </div>
    <div class="card-body">
      <ng-content select="[cardBody1]"></ng-content>
      <ng-content select="[cardText1]"></ng-content>
      <ng-content select="[cardLink1]"></ng-content>
    </div>
    <div class="card-footer">
      <ng-content select="[cardFooter1]"></ng-content>
    </div>
  </div>

  <div *ngSwitchCase="2" class="card mb-3 w-100 card_type_2">
    <div class="row no-gutters">
      <div class="col-md-4">
        <img [src]="imgSrc" class="card-img img-thumbnail" alt="" />
      </div>
      <div class="col-md-8">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center">
            <div style="width: 20%">
              <ng-content select="[card2LeftBtn1]"></ng-content>
              <ng-content select="[card2LeftBtn2]"></ng-content>
            </div>
            <h3 class="card-title text-center" style="width: 80%">{{ title }}</h3>
            <div style="width: 20%">
              <ng-content select="[card2RightBtn1]"></ng-content>
              <button *ngIf="showEditButton" (click)="showHideEditForm()" class="btn btn-secondary rounded-circle float-right">
                <ng-content select="[cardButton2]"></ng-content>
              </button>
            </div>
          </div>
          <div class="card-text">
            <ng-content select="[cardText2]"></ng-content>
          </div>
          <small class="text-muted">
            <ng-content select="[cardTextMuted2]"></ng-content>
          </small>
        </div>
      </div>
    </div>
  </div>

  <div *ngSwitchCase="3" class="card w-100 card_type_3">
    <div class="card-header d-flex justify-content-between align-items-center">
      <div style="width: 15%">
        <ng-content select="[card3BtnLeft1]"></ng-content>
        <ng-content select="[card3BtnLeft2]"></ng-content>
        <ng-content select="[card3BtnLeft3]"></ng-content>
      </div>
      <h3>{{ title }}</h3>
      <div style="width: 15%" class="d-flex justify-content-end align-items-center">
        <ng-content select="[card3BtnRight1]"></ng-content>
        <ng-content select="[card3BtnRight2]"></ng-content>
        <ng-content select="[card3BtnRight3]"></ng-content>
        <ng-content select="[cardEsc3]"></ng-content>
      </div>
    </div>
    <div class="card-body">
      <ng-content select="[cardBody3]"></ng-content>
      <ng-content select="[cardText3]"></ng-content>
      <ng-content select="[cardLink3]"></ng-content>
    </div>
  </div>
</ng-container>
